import { handleRequest } from "../utilities/requestHandler";

export const getSavedForLaterBySiteId = (siteNumber) =>
    handleRequest("post", "/saved_for_later/bysiteid", {
        site_number: siteNumber,
    });

export const removeFromSavedForLater = (productIds, siteNumber) =>
    handleRequest("post", "/saved_for_later/remove", {
        product_ids: productIds,
        site_number: siteNumber,
    });
